import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import { applyDirAndFontForLang } from './i18n';
import i18n from './i18n';
import { LandingPage } from './pages/LandingPage';
import { StartPage } from './pages/StartPage';
import { ChatPage } from './pages/ChatPage';
import { DonePage } from './pages/DonePage';
import { InformativaPage } from './pages/InformativaPage';
import { PrivacyLandingPage } from './pages/PrivacyLandingPage';
import { PrivacyAccessPage } from './pages/PrivacyAccessPage';
import { PrivacyDeletePage } from './pages/PrivacyDeletePage';
import { KioskProvider } from './lib/kiosk';
import { KioskExitButton } from './components/KioskExitButton';
import { useKiosk } from './lib/kiosk';
import './index.css';

// Applica dir/font in base alla lingua iniziale + ad ogni cambio.
applyDirAndFontForLang(i18n.resolvedLanguage ?? 'it');
i18n.on('languageChanged', (lng) => applyDirAndFontForLang(lng));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 60_000 },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root non trovato');

function KioskMaybeExit() {
  const { enabled } = useKiosk();
  return enabled ? <KioskExitButton /> : null;
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/chat">
        <KioskProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/start" element={<StartPage />} />
            <Route path="/c/:sessionId" element={<ChatPage />} />
            <Route path="/done/:pickupCode" element={<DonePage />} />
            <Route path="/informativa" element={<InformativaPage />} />
            <Route path="/privacy" element={<PrivacyLandingPage />} />
            <Route path="/privacy/access" element={<PrivacyAccessPage />} />
            <Route path="/privacy/delete" element={<PrivacyDeletePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <KioskMaybeExit />
        </KioskProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
